import { createStyles } from '@material-ui/core/styles';
import { LumaTheme } from 'embeds/core/styles/getTheme';

export const useStyles = ({
  custom: {
    palette: { colorAccentWatermelon, colorVeryLightGray },
  },
}: LumaTheme) =>
  createStyles({
    unsupportedDiv: {
      textAlign: 'center',
      backgroundColor: colorAccentWatermelon,
      color: colorVeryLightGray,
      width: '100%',
      padding: 10,
    },
    unsupportedBody: {
      color: colorVeryLightGray,
    },
    link: {
      color: colorVeryLightGray,
    },
  });
